import request from '@/utils/request'


// 查询产品规格组合列表
export function listSpecCombination(query) {
  return request({
    url: '/user/goods-spec-combination/list',
    method: 'get',
    params: query
  })
}

// 查询产品规格组合分页
export function pageSpecCombination(query) {
  return request({
    url: '/user/goods-spec-combination/page',
    method: 'get',
    params: query
  })
}

// 查询产品规格组合详细
export function getSpecCombination(data) {
  return request({
    url: '/user/goods-spec-combination/detail',
    method: 'get',
    params: data
  })
}

// 新增产品规格组合
export function addSpecCombination(data) {
  return request({
    url: '/user/goods-spec-combination/add',
    method: 'post',
    data: data
  })
}

// 修改产品规格组合
export function updateSpecCombination(data) {
  return request({
    url: '/user/goods-spec-combination/edit',
    method: 'post',
    data: data
  })
}

// 删除产品规格组合
export function delSpecCombination(data) {
  return request({
    url: '/user/goods-spec-combination/delete',
    method: 'post',
    data: data
  })
}
